var render = function render(){var _vm=this,_c=_vm._self._c;return _c('standard-page',{key:_vm.$route.path,attrs:{"title":_vm.title,"content":_vm.filteredContent}})
}
var staticRenderFns = []

export { render, staticRenderFns }